module.exports = __webpack_public_path__ + "static/media/flat-project-image.e721c682.jpg";